var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import theme from '../../theme';
const Container = styled((_a) => {
    var { theme, customStyle } = _a, rest = __rest(_a, ["theme", "customStyle"]);
    return <View {...rest}/>;
}) `
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  background-color: ${({ theme }) => theme.WhiteColor};
  ${({ customStyle }) => customStyle};
`;
Container.defaultProps = {
    theme: {
        WhiteColor: theme.WhiteColor,
    },
};
export default Container;
